import React from 'react';
import {observable, action, computed, makeObservable} from 'mobx';
import {observer} from 'mobx-react';
import s from '../../s';
import {linoStore} from './lino-store';
import {linoGirlScoutsAutographStore} from './lino-girl-scouts-autograph/lino-girl-scouts-autograph.store';
import {LINO_OPTIONS} from './lino-girl-scouts-autograph/lino-options';
import * as emitter from '../../../global/emitter';

declare var __portal: IPortalSettings;

@observer
export default class Lino extends React.Component {
    @observable collapsed: boolean = true;
    @observable init_linos: boolean = false;
    @observable hasCategory1: boolean = false;
    @observable hasCategory2: boolean = false;
    @observable hasCategory3: boolean = false;
    @observable hasCategory4: boolean = false;
    @observable hasCategory5: boolean = false;
    @observable orig_lino_name: string = '';
    @observable lino_display_name: string = '';
    @observable lino_color: string = '';
    @observable lino_select_text: string = '';
    @observable IsMultipleColors: boolean = false;

    constructor(props) {
        super(props);
        this.collapseToggle = this.collapseToggle.bind(this);
        this.initLinos = this.initLinos.bind(this);
        this.orig = this.orig.bind(this);
        this.changeLino = this.changeLino.bind(this);
        this.changeLinoColor = this.changeLinoColor.bind(this);
        this.lino_remove = this.lino_remove.bind(this);

        if(s.si.ProductLinoSelectionText && s.si.ProductLinoSelectionText.toLocaleLowerCase().includes('school') && s.currentGradSchoolID < 1){
            this.lino_select_text = 'School';
        } else {
            this.lino_select_text = s.si.ProductLinoSelectionText ? s.si.ProductLinoSelectionText : 'Embossed Text';
        }
        
        if (s.prod.ProductTypeID === 83 || s.prod.ProductTypeID === 84 || s.prod.ProductTypeID === 87) {
            this.lino_select_text = 'Embossed Text';
        }
        makeObservable(this);
    }

    @action
    collapseToggle = async () => {
        this.collapsed = !this.collapsed;
    };

    @action
    initLinos = async () => {
        this.orig_lino_name = JSON.parse(JSON.stringify(s.prod.orig_pcs.Base_LinoName));
        this.lino_display_name = s.prod.LinoDisplayName;
        this.lino_color = s.prod.LinoColor;
        this.hasCategory1 = s.prod && s.prod.linos && s.prod.linos.filter(m => !m.isBase && m.dyf_custom_lino_type_id === 1).length > 0;
        this.hasCategory2 = s.prod && s.prod.linos && s.prod.linos.filter(m => !m.isBase && m.dyf_custom_lino_type_id === 2).length > 0;
        this.hasCategory3 = s.prod && s.prod.linos && s.prod.linos.filter(m => !m.isBase && m.dyf_custom_lino_type_id === 3).length > 0;
        this.hasCategory4 = s.prod && s.prod.linos && s.prod.linos.filter(m => !m.isBase && m.dyf_custom_lino_type_id === 4).length > 0;
        this.hasCategory5 = s.prod && s.prod.linos && s.prod.linos.filter(m => !m.isBase && m.dyf_custom_lino_type_id === 5).length > 0;
        this.init_linos = true;

        const uniqueColors = new Set(s.prod.linos.map(item => item.desc4));
        this.IsMultipleColors = uniqueColors.size > 1;
    };

    @action
    orig = async () => {
        s.pcs.lino_id = s.prod.LinoID;
        s.pcs.lino_base_name = this.orig_lino_name;
        s.pcs.lino_text = this.orig_lino_name;
        s.pcs.lino_dyf_color = 'Gold';
        s.pcs.lino_is_dyf = false;
        s.pcs.ep_id = 0;
        s.ui.update_pricing = true;
        s.ui.doRender = true;
        this.lino_display_name = s.prod.LinoDisplayName;
        this.lino_color = s.prod.LinoColor;
        s.pulse();
    };

    @action
    changeLino = async (dyf_custom_lino_type_id: number, e: React.ChangeEvent<HTMLSelectElement>) => {
        const m = s.prod.linos.filter(m => !m.isBase && m.dyf_custom_lino_type_id === dyf_custom_lino_type_id && m.id === parseInt(e.target.value, 10))[0];

        if (m) {
            s.pcs.lino_id = m.id;
            s.pcs.lino_base_name = m.name;
            s.pcs.lino_text = m.name;
            s.pcs.lino_is_dyf = true;
            s.pcs.ep_id = 0;
            this.lino_display_name = m.title;
            this.lino_color = m.desc4;
            s.pcs.lino_dyf_color = m.desc4;
        }
        s.ui.update_pricing = true;
        s.ui.doRender = true;

        const f1 = document.getElementById('lino-dyf-1');
        const f2 = document.getElementById('lino-dyf-2');
        const f3 = document.getElementById('lino-dyf-3');
        const f4 = document.getElementById('lino-dyf-4');
        const f5 = document.getElementById('lino-dyf-5');

        if (f1 && m && m.dyf_custom_lino_type_id !== 1) {
            f1.getElementsByTagName('option')[0].selected = true;
        }
        if (f2 && m && m.dyf_custom_lino_type_id !== 2) {
            f2.getElementsByTagName('option')[0].selected = true;
        }
        if (f3 && m && m.dyf_custom_lino_type_id !== 3) {
            f3.getElementsByTagName('option')[0].selected = true;
        }
        if (f4 && m && m.dyf_custom_lino_type_id !== 4) {
            f4.getElementsByTagName('option')[0].selected = true;
        }
        if (f5 && m && m.dyf_custom_lino_type_id !== 5) {
            f5.getElementsByTagName('option')[0].selected = true;
        }

        if (!s.pcs.lino_dyf_color || s.pcs.lino_dyf_color === '') {
            if (s.pcs.ins_gold_allowed) {
                s.pcs.lino_dyf_color = 'gold';
            } else if (s.pcs.ins_silver_allowed) {
                s.pcs.lino_dyf_color = 'silver';
            } else if (s.pcs.ins_black_allowed) {
                s.pcs.lino_dyf_color = 'black';
            }
        }

        s.pulse();

        emitter.eventEmitter.dispatch(emitter.EventType.AB, 'lino_changed');

        if (window.innerWidth < 1200) {
            const d = document.getElementById('prod-header') as HTMLDivElement;
            d.scrollIntoView();
        }
    };

    @action
    changeLinoProd = async (_id: number) => {
        const m = s.prod.linos.filter(m => m.id === _id)[0];
        if (m) {
            s.pcs.lino_base_name = m.name;
            s.pcs.lino_is_dyf = false;
            s.pcs.lino_id = m.id;
            s.pcs.lino_text = m.title;
            s.pcs.ep_id = 0;
            this.lino_display_name = m.title;
            this.lino_color = m.desc4;

            let hasGSMatch = false;
            if (m.gradSchoolId > 0 && s.si.ProductDocSizes && s.si.ProductDocSizes.length > 0) {
                const now = new Date();

                let gsMatch = s.si.ProductDocSizes.find(item => item.GradSchoolID === m.gradSchoolId && new Date(item.StartDate) < now && new Date(item.EndDate) > now && item.StatusID === 1 && item.DocType === 1);

                if (gsMatch) {
                    hasGSMatch = true;
                    s.pcs.docWidth = gsMatch.Doc_Width;
                    s.pcs.docHeight = gsMatch.Doc_Height;
                } else {
                    gsMatch = s.si.ProductDocSizes.find(item => item.ApplyToGradSchools && item.GradSchoolID < 1 && new Date(item.StartDate) < now && new Date(item.EndDate) > now && item.StatusID === 1 && item.DocType === 1);
                    if (gsMatch) {
                        hasGSMatch = true;
                        s.pcs.docWidth = gsMatch.Doc_Width;
                        s.pcs.docHeight = gsMatch.Doc_Height;
                    }
                }
            }

            if (s.si.ProductDocSizes && s.si.ProductDocSizes.length > 0 && !hasGSMatch) {
                const now = new Date();
                const gsMatch2 = s.si.ProductDocSizes.find(item => item.GradSchoolID < 1 && new Date(item.StartDate) < now && new Date(item.EndDate) > now && item.StatusID === 1 && item.DocType === 1 && !item.ApplyToGradSchools);

                if (gsMatch2) {
                    s.pcs.docWidth = gsMatch2.Doc_Width;
                    s.pcs.docHeight = gsMatch2.Doc_Height;
                }
            }
        }

        if (!s.prod.IsCAF) {
            s.currentGradSchoolID = m.gradSchoolId;

            if(s.currentGradSchoolID > 0){
                this.lino_select_text = s.si.ProductLinoSelectionText ? s.si.ProductLinoSelectionText : 'Graduate School';
            } else {
                this.lino_select_text = s.si.ProductLinoSelectionText && s.si.ProductLinoSelectionText.toLocaleLowerCase().includes('school') ? 'School' : 'Embossed Text';
            }
        }

        s.ui.update_pricing = true;
        s.ui.doRender = true;
        s.pulse();
        emitter.eventEmitter.dispatch(emitter.EventType.AB, 'lino_changed');

        if (window.innerWidth < 1200) {
            const d = document.getElementById('prod-header') as HTMLDivElement;
            d.scrollIntoView();
        }
    };

    @computed get canCollapse(): boolean {
        return s.pcs.is_caf || window.innerWidth < 960;
    }

    @computed get getOptionsCount(): number {
        let i = s.pcs.ins_gold_allowed ? 1 : 0;
        i += s.pcs.ins_black_allowed ? 1 : 0;
        i += s.pcs.ins_silver_allowed ? 1 : 0;
        return i;
    }

    @action
    changeLinoColor = async (e: React.ChangeEvent<HTMLSelectElement>) => {
        s.pcs.lino_dyf_color = e.target.value.toString().trim().toLowerCase();
        s.ui.update_pricing = true;
        s.ui.doRender = true;
        s.pulse();
    };

    @action
    lino_remove = async () => {
        s.pcs.lino_id = -1;
        const f1 = document.getElementById('lino-dyf-1');
        const f2 = document.getElementById('lino-dyf-2');
        const f3 = document.getElementById('lino-dyf-3');
        const f4 = document.getElementById('lino-dyf-4');
        const f5 = document.getElementById('lino-dyf-5');

        if (f1) {
            f1.getElementsByTagName('option')[0].selected = true;
        }
        if (f2) {
            f2.getElementsByTagName('option')[0].selected = true;
        }
        if (f3) {
            f3.getElementsByTagName('option')[0].selected = true;
        }
        if (f4) {
            f4.getElementsByTagName('option')[0].selected = true;
        }
        if (f5) {
            f5.getElementsByTagName('option')[0].selected = true;
        }
        s.ui.update_pricing = true;
        s.ui.doRender = true;
        s.pulse();
    };

    async handleLinoDropdown(id: string) {
        if (id === '-1') {
            await this.orig();
        } else {
            await this.changeLinoProd(+id);
        }
    }

    handleLinoDropdownGSAutograph(e: React.ChangeEvent<HTMLSelectElement>, lino?: string, isNameSelect = false) {
        const state = isNameSelect ? linoGirlScoutsAutographStore.selectedState : e.target.value;
        const title = isNameSelect ? e.target.value : lino;
        const selectedLino = LINO_OPTIONS.find(i => i.state === state && i.title === title);
        const combined = `${title}${!title?.includes(state) && state !== '-1' ? ` ${state}` : ''}`;
        const id = selectedLino?.id as number;
        const url = selectedLino?.productImageUrl as string;

        this.lino_display_name = combined;
        s.pcs.lino_id = id;
        s.pcs.lino_text = combined;
        s.pcs.custom_text_1 = combined;
        linoGirlScoutsAutographStore.productImageUrl = url;
    }

    render() {
        // console.log(s.prod.linos.length);
        if (!s.ui.show_cust || !s.prod || !s.prod.linos) {
            return;
        }
        if (!this.init_linos) {
            this.initLinos();
        }

        if (s.si.StoreID === 205164) {
            if (s.prod.ProductID === 88937) {
                linoGirlScoutsAutographStore.getData();
            } else {
                linoStore.getData();
            }
        }

        // console.log(s.prod.linos.length);

        return (
            <div
                className="gray-box lino-prod"
                style={{padding: 0}}
            >
                <div className={this.canCollapse ? '' : ''}>
                    <div
                        style={{
                            padding: '0 12px',
                            position: 'relative',
                        }}
                    >
                        <div
                            role={this.canCollapse ? 'button' : undefined}
                            tabIndex={this.canCollapse ? 0 : undefined}
                            onKeyDown={e => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    e.currentTarget.click();
                                }
                            }}
                            className="d-none d-xl-block toggle-bs"
                            data-bs-toggle={this.canCollapse ? 'collapse' : ''}
                            data-bs-target="#lino-inner"
                            aria-expanded={this.canCollapse ? false : undefined}
                            aria-controls={this.canCollapse ? 'lino-inner' : undefined}
                        >
                            <div className="cust-desktop-head">
                                <span>{this.lino_select_text}: </span>
                                {s.prod.IsCAF && <span>{s.pcs.lino_id > 0 ? s.pcs.lino_base_name : ''}</span>}
                                {!s.prod.IsCAF && (s.prod.ProductTypeID === 83 || s.prod.ProductTypeID === 84 || s.prod.ProductTypeID === 87) && (
                                    <span>{s.pcs.lino_id > 0 ? `${this.lino_display_name.includes(this.lino_color) ? this.lino_display_name : this.lino_display_name + (s.prod.LinoID === s.pcs.lino_id ? ` ${this.lino_color}` : '')}` : ''}</span>
                                )}
                                {!s.prod.IsCAF && !(s.prod.ProductTypeID === 83 || s.prod.ProductTypeID === 84 || s.prod.ProductTypeID === 87) && <span>{s.pcs.lino_id > 0 ? this.lino_display_name : ''}</span>}
                            </div>
                        </div>

                        <div
                            role="button"
                            tabIndex={0}
                            onKeyDown={e => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    e.currentTarget.click();
                                }
                            }}
                            className="d-block d-xl-none toggle-bs"
                            data-bs-toggle={this.canCollapse ? 'collapse' : ''}
                            data-bs-target="#lino-inner"
                            aria-expanded={this.canCollapse ? false : undefined}
                            aria-controls={this.canCollapse ? 'lino-inner' : undefined}
                        >
                            <div className="cust-flex-head">
                                <div>
                                    <div
                                        className="header-std flexer cust-flex2"
                                        style={{paddingRight: '0.25rem'}}
                                    >
                                        {this.lino_select_text}
                                    </div>
                                    <div className="cust-flex2">
                                        {s.prod.IsCAF && <span>{s.pcs.lino_id > 0 ? s.pcs.lino_base_name : ''}</span>}
                                        {!s.prod.IsCAF && (s.prod.ProductTypeID === 83 || s.prod.ProductTypeID === 84 || s.prod.ProductTypeID === 87) && (
                                            <span>
                                                {s.pcs.lino_id > 0 ? this.lino_display_name : ''}
                                                {s.pcs.lino_id > 0 && s.prod.LinoID === s.pcs.lino_id ? ` ${this.lino_color}` : ''}
                                            </span>
                                        )}
                                        {!s.prod.IsCAF && !(s.prod.ProductTypeID === 83 || s.prod.ProductTypeID === 84 || s.prod.ProductTypeID === 87) && <span>{s.pcs.lino_id > 0 ? this.lino_display_name : ''}</span>}
                                    </div>
                                </div>
                                <div>
                                    {this.canCollapse && this.collapsed && s.pcs.lino_id > 0 && (
                                        <img
                                            src={s.pcs.css.lino_src}
                                            className="th-h"
                                            alt={`${this.lino_select_text} Thumbnail`}
                                            style={{
                                                backgroundColor: `#${s.ui.color_mat1}`,
                                                width: 120,
                                                marginTop: 6,
                                            }}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div
                        id="lino-inner"
                        className={this.canCollapse ? 'collapse' : ''}
                        aria-label="Select Lino"
                        style={{padding: '0 12px'}}
                    >
                        {((this.getOptionsCount > 1 &&
                            s.prod.LinoID !== s.pcs.lino_id &&
                            (!s.prod.linos || s.prod.linos.length < 2 || s.pcs.is_caf) &&
                            s.prod.ProductID !== 75593 &&
                            s.prod.ProductID !== 75595 &&
                            s.prod.ProductID !== 75591 &&
                            s.prod.ProductID !== 75589 &&
                            s.prod.ProductID !== 88937) ||
                            s.hasDYFLinoNonProduct) && (
                            <div>
                                <div className="form-floating cust-lino-select">
                                    <select
                                        id="lino-color"
                                        className="form-select"
                                        aria-label="Select lino color"
                                        onChange={this.changeLinoColor}
                                    >
                                        {s.pcs.ins_black_allowed && (
                                            <option
                                                value="black"
                                                selected={s.pcs.lino_dyf_color === 'black'}
                                            >
                                                Black
                                            </option>
                                        )}
                                        {s.pcs.ins_gold_allowed && (
                                            <option
                                                value="gold"
                                                selected={s.pcs.lino_dyf_color === 'gold'}
                                            >
                                                Gold
                                            </option>
                                        )}
                                        {s.pcs.ins_silver_allowed && (
                                            <option
                                                value="silver"
                                                selected={s.pcs.lino_dyf_color === 'silver'}
                                            >
                                                Silver
                                            </option>
                                        )}
                                    </select>
                                    <label htmlFor="lino-color">{this.lino_select_text} Color</label>
                                </div>
                            </div>
                        )}

                        <div
                            id="lino-inner2"
                            style={{gap: 2}}
                        >
                            {s.prod.LinoID > 0 && s.prod.linos.length < 3 && s.prod.ProductID !== 88937 && (
                                <div
                                    className={`cust-entity${s.prod.LinoID === s.pcs.lino_id ? ' active' : ''}`}
                                    style={{
                                        margin: '4px 2px',
                                        borderRadius: '0.375rem',
                                        height: 46,
                                        lineHeight: '46px',
                                        paddingTop: 0,
                                        paddingBottom: 0,
                                        width: 'auto',
                                    }}
                                    role="option"
                                    tabIndex={0}
                                    onClick={this.orig}
                                    onKeyDown={e => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                            e.preventDefault();
                                            this.orig();
                                        }
                                    }}
                                    aria-label={`Select original ${this.lino_select_text.toLowerCase()}`}
                                >
                                    {s.prod.ProductTypeID == 83 || s.prod.ProductTypeID == 84 || s.prod.ProductTypeID == 87 ? `${s.prod.LinoDisplayName} ${s.prod.LinoColor}` : __portal.PortalID === 0 ? this.orig_lino_name : 'Select your program'}
                                </div>
                            )}

                            {s.prod.linos.length === 2 &&
                                s.prod.ProductID !== 88937 &&
                                s.prod.linos
                                    .filter(m => !m.isBase && !m.isCAF)
                                    .map((m, i) => (
                                        <div
                                            key={i}
                                            className={`cust-entity${s.pcs.lino_id === m.id ? ' active' : ''}`}
                                            role="option"
                                            style={{
                                                margin: '4px 2px',
                                                borderRadius: '0.375rem',
                                                height: 46,
                                                lineHeight: '46px',
                                                paddingTop: 0,
                                                paddingBottom: 0,
                                                width: 'auto',
                                            }}
                                            onClick={e => this.changeLinoProd(m.id)}
                                            onKeyDown={e => {
                                                if (e.key === 'Enter' || e.key === ' ') {
                                                    e.preventDefault();
                                                    this.changeLinoProd(m.id);
                                                }
                                            }}
                                            aria-label={`Select ${m.title} ${this.lino_select_text.toLowerCase()}`}
                                            tabIndex={0}
                                        >
                                            {s.prod.ProductTypeID == 83 || s.prod.ProductTypeID == 84 || s.prod.ProductTypeID == 87 ? m.title.trim() : m.title.replace(s.si.InstName, '').trim()}
                                        </div>
                                    ))}

                            {!s.prod.IsCAF && ((s.prod.linos.length > 2 && s.hasSomeProductLino) || s.prod.ProductID === 88937) && (
                                <div
                                    className="form-floating cust-lino-select"
                                    style={{width: '100%', margin: 0, maxWidth: s.si.StoreID === 205164 ? 400 : 300}}
                                >
                                    {s.si.StoreID === 205164 ? (
                                        s.prod.ProductID === 88937 ? (
                                            <div style={{display: 'flex', flexDirection: 'column', gap: 10}}>
                                                <select
                                                    id="lino-prod-select-1"
                                                    className="form-select"
                                                    style={{paddingTop: 10, paddingBottom: 10, height: '100%', width: 'auto'}}
                                                    aria-label="Select embossed text"
                                                    onChange={e => {
                                                        linoGirlScoutsAutographStore.setSelected(e.target.value);
                                                        this.handleLinoDropdownGSAutograph(e, linoGirlScoutsAutographStore.nameOptionsFiltered.length ? linoGirlScoutsAutographStore.nameOptionsFiltered[0].title : linoGirlScoutsAutographStore.selectedState);
                                                    }}
                                                >
                                                    <option
                                                        key={-1}
                                                        value={-1}
                                                    >
                                                        {LINO_OPTIONS[0].title}
                                                    </option>
                                                    {linoGirlScoutsAutographStore.stateOptions.map((i, index) => (
                                                        <option
                                                            key={index}
                                                            value={i}
                                                        >
                                                            {i}
                                                        </option>
                                                    ))}
                                                </select>

                                                {linoGirlScoutsAutographStore.selectedState && linoGirlScoutsAutographStore.selectedState !== '-1' && (
                                                    <select
                                                        id="lino-prod-select-2"
                                                        className="form-select"
                                                        aria-label="Select embossed text"
                                                        style={{paddingTop: 10, paddingBottom: 10, height: '100%', width: 'auto'}}
                                                        onChange={e => this.handleLinoDropdownGSAutograph(e, undefined, true)}
                                                    >
                                                        {linoGirlScoutsAutographStore.nameOptionsFiltered.map((i, index) => (
                                                            <option
                                                                key={index}
                                                                value={i.title}
                                                            >
                                                                {i.title}
                                                            </option>
                                                        ))}
                                                    </select>
                                                )}
                                            </div>
                                        ) : (
                                            <div style={{display: 'flex', flexDirection: 'column', gap: 10}}>
                                                <select
                                                    id="lino-prod-select-1"
                                                    className="form-select"
                                                    style={{paddingTop: 10, paddingBottom: 10, height: '100%', width: 'auto'}}
                                                    aria-label={`Select ${this.lino_select_text.toLowerCase()}`}
                                                    onChange={e => {
                                                        linoStore.setSelected(e.target.value);
                                                        this.handleLinoDropdown(linoStore.desc2OptionsFiltered.length ? linoStore.desc2OptionsFiltered[0].id.toString() : linoStore.selectedDesc1);
                                                    }}
                                                >
                                                    <option
                                                        key={-1}
                                                        value={-1}
                                                    >
                                                        {s.prod.ProductTypeID == 83 || s.prod.ProductTypeID == 84 || s.prod.ProductTypeID == 87 ? `${s.prod.LinoDisplayName} ${s.prod.LinoColor}` : __portal.PortalID === 0 ? this.lino_display_name : 'Select your program'}
                                                    </option>
                                                    {linoStore.desc1Options.map((i, index) => (
                                                        <option
                                                            key={index}
                                                            value={i}
                                                        >
                                                            {i}
                                                        </option>
                                                    ))}
                                                </select>

                                                {linoStore.selectedDesc1 && linoStore.selectedDesc1 !== '-1' && (
                                                    <select
                                                        id="lino-prod-select-2"
                                                        className="form-select"
                                                        aria-label={`Select ${this.lino_select_text.toLowerCase()}`}
                                                        style={{paddingTop: 10, paddingBottom: 10, height: '100%', width: 'auto'}}
                                                        onChange={e => this.handleLinoDropdown(e.target.value)}
                                                    >
                                                        {linoStore.desc2OptionsFiltered.map((i, index) => (
                                                            <option
                                                                key={index}
                                                                value={i.id}
                                                            >
                                                                {i.desc2}
                                                            </option>
                                                        ))}
                                                    </select>
                                                )}
                                            </div>
                                        )
                                    ) : (
                                        <select
                                            id="lino-prod-select"
                                            className="form-select"
                                            aria-label={`Select ${this.lino_select_text.toLowerCase()}`}
                                            style={{paddingTop: 10, paddingBottom: 10, height: '100%', width: 'auto'}}
                                            onChange={e => this.handleLinoDropdown(e.target.value)}
                                        >
                                            {s.prod.linos
                                                .filter(m => !m.isCAF)
                                                .map((m, i) => (
                                                    <option
                                                        key={i}
                                                        value={m.id}
                                                    >
                                                        {s.prod.ProductTypeID == 83 || s.prod.ProductTypeID == 84 || s.prod.ProductTypeID == 87 ? m.title.trim() : m.isBase ? m.title : m.title.replace(s.si.InstName, '').trim() == '' ? m.title : m.title.replace(s.si.InstName, '').trim()}{' '}
                                                        {this.IsMultipleColors ? ` - ${m.desc4}` : ''}
                                                    </option>
                                                ))}
                                        </select>
                                    )}
                                </div>
                            )}

                            {this.hasCategory1 && (
                                <div className="form-floating cust-lino-select">
                                    <select
                                        id="lino-dyf-1"
                                        className="form-select"
                                        aria-label="Select lino"
                                        onChange={e => this.changeLino(1, e)}
                                    >
                                        <option
                                            key={-1}
                                            value={-1}
                                        >
                                            School of...
                                        </option>
                                        {s.prod &&
                                            s.prod.linos &&
                                            s.prod.linos
                                                .filter(m => !m.isBase && m.dyf_custom_lino_type_id === 1)
                                                .map((m, i) => (
                                                    <option
                                                        key={i}
                                                        value={m.id}
                                                    >
                                                        {m.title}
                                                    </option>
                                                ))}
                                    </select>
                                    <label htmlFor="lino-dyf-1">Select School</label>
                                </div>
                            )}

                            {this.hasCategory2 && (
                                <div className="form-floating cust-lino-select">
                                    <select
                                        id="lino-dyf-2"
                                        className="form-select"
                                        aria-label="Select lino"
                                        onChange={e => this.changeLino(2, e)}
                                    >
                                        <option
                                            key={-1}
                                            value={-1}
                                        >
                                            College of...
                                        </option>
                                        {s.prod &&
                                            s.prod.linos &&
                                            s.prod.linos
                                                .filter(m => !m.isBase && m.dyf_custom_lino_type_id === 2)
                                                .map((m, i) => (
                                                    <option
                                                        key={i}
                                                        value={m.id}
                                                    >
                                                        {m.title}
                                                    </option>
                                                ))}
                                    </select>
                                    <label htmlFor="lino-dyf-2">Select College</label>
                                </div>
                            )}

                            {this.hasCategory3 && (
                                <div className="form-floating cust-lino-select">
                                    <select
                                        id="lino-dyf-3"
                                        className="form-select"
                                        aria-label="Select lino"
                                        onChange={e => this.changeLino(3, e)}
                                    >
                                        <option
                                            key={-1}
                                            value={-1}
                                        >
                                            State of...
                                        </option>
                                        {s.prod &&
                                            s.prod.linos &&
                                            s.prod.linos
                                                .filter(m => !m.isBase && m.dyf_custom_lino_type_id === 3)
                                                .map((m, i) => (
                                                    <option
                                                        key={i}
                                                        value={m.id}
                                                    >
                                                        {m.title}
                                                    </option>
                                                ))}
                                    </select>
                                    <label htmlFor="lino-dyf-3">Select State</label>
                                </div>
                            )}

                            {this.hasCategory4 && (
                                <div className="form-floating cust-lino-select">
                                    <select
                                        id="lino-dyf-4"
                                        className="form-select"
                                        aria-label="Select lino"
                                        onChange={e => this.changeLino(4, e)}
                                    >
                                        <option
                                            key={-1}
                                            value={-1}
                                        >
                                            Class of...
                                        </option>
                                        {s.prod &&
                                            s.prod.linos &&
                                            s.prod.linos
                                                .filter(m => !m.isBase && m.dyf_custom_lino_type_id === 4)
                                                .reverse()
                                                .map((m, i) => (
                                                    <option
                                                        key={i}
                                                        value={m.id}
                                                    >
                                                        {m.title}
                                                    </option>
                                                ))}
                                    </select>
                                    <label htmlFor="lino-dyf-4">Select Class</label>
                                </div>
                            )}

                            {this.hasCategory5 && (
                                <div className="form-floating cust-lino-select">
                                    <select
                                        id="lino-dyf-5"
                                        className="form-select"
                                        aria-label="Select lino"
                                        onChange={e => this.changeLino(5, e)}
                                    >
                                        <option
                                            key={-1}
                                            value={-1}
                                        >
                                            Doctor of...
                                        </option>
                                        {s.prod &&
                                            s.prod.linos &&
                                            s.prod.linos
                                                .filter(m => !m.isBase && m.dyf_custom_lino_type_id === 5)
                                                .reverse()
                                                .map((m, i) => (
                                                    <option
                                                        key={i}
                                                        value={m.id}
                                                    >
                                                        {m.title}
                                                    </option>
                                                ))}
                                    </select>
                                    <label htmlFor="lino-dyf-5">Select Doctor Of</label>
                                </div>
                            )}

                            {s.pcs.lino_is_dyf && s.pcs.lino_id > 0 && s.prod.ProductID !== 88937 && (
                                <div role="option">
                                    <hr style={{margin: '0.5rem 0'}} />
                                    <div style={{backgroundColor: `#${s.pcs.mat1_color}`}}>
                                        {s.pcs.lino_is_dyf && (
                                            <img
                                                className="resp"
                                                src={`https://${s.Portal.CDNDomain}/images/entities/linotype_caf/v2/${s.pcs.lino_base_name.replace(/ /g, '_')}_${s.pcs.lino_dyf_color}.png`.toLowerCase()}
                                                alt={`Selected ${this.lino_select_text}`}
                                            />
                                        )}
                                    </div>
                                </div>
                            )}

                            {!s.pcs.lino_is_dyf && s.pcs.lino_id > 0 && s.prod.ProductID !== 88937 && (
                                <div role="option">
                                    <hr style={{margin: '0.5rem 0'}} />
                                    <div style={{backgroundColor: `#${s.pcs.mat1_color}`}}>
                                        {!s.pcs.lino_is_dyf && (
                                            <img
                                                className="resp"
                                                src={`https://${s.Portal.CDNDomain}/images/entities/linotype_product/v2/${s.pcs.lino_base_name.replace(/ /g, '_')}_original.png`.toLowerCase()}
                                                alt={`Selected ${this.lino_select_text.toLowerCase()}`}
                                            />
                                        )}
                                    </div>
                                </div>
                            )}

                            {((s.pcs.is_caf && s.pcs.lino_id > 0) || (!s.pcs.is_caf && s.pcs.lino_id > 0 && s.prod.LinoID < 1)) && (
                                <div
                                    className="ep-toggle text-center"
                                    style={{marginBottom: '1rem'}}
                                >
                                    <hr style={{margin: '0.5rem 0'}} />
                                    <button
                                        type="button"
                                        aria-label={`Remove ${this.lino_select_text.toLowerCase()} from product`}
                                        className="btn btn-secondary"
                                        onClick={this.lino_remove}
                                    >
                                        Remove {this.lino_select_text}
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
